module.exports = __webpack_public_path__ + "static/media/icon_nps_active.967bd612.svg";